import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n'; // Add import for translation function
import './ProductDetail.css';

const generateReviews = (productId) => {
  const reviewsData = {
    1: [ // Fullerene C60 - 25 total, 5 with text
      { 
        name: { bg: "Мария Петрова", en: "Maria Petrova" }, 
        rating: 5, 
        comment: { 
          bg: "Невероятен ефект върху косата ми! След 2 месеца употреба забелязах значително подобрение в растежа и качеството на косата.", 
          en: "Amazing effect on my hair! After 2 months of use, I noticed a significant improvement in the growth and quality of my hair."
        }, 
        date: { bg: "15 ноем. 2024", en: "Nov 15, 2024" } 
      },
      { 
        name: { bg: "Димитър Николов", en: "Dimitar Nikolov" }, 
        rating: 4, 
        comment: { 
          bg: "Много добър продукт, макар и малко скъп. Определено виждам резултати.", 
          en: "Very good product, although a bit expensive. I definitely see results."
        }, 
        date: { bg: "8 ноем. 2024", en: "Nov 8, 2024" } 
      },
      { 
        name: { bg: "Елена Георгиева", en: "Elena Georgieva" }, 
        rating: 5, 
        comment: { 
          bg: "Препоръчвам! Косата ми стана много по-плътна и здрава.", 
          en: "I recommend it! My hair became much thicker and healthier."
        }, 
        date: { bg: "2 ноем. 2024", en: "Nov 2, 2024" } 
      },
      { 
        name: { bg: "Петър Иванов", en: "Peter Ivanov" }, 
        rating: 4, 
        comment: { 
          bg: "Добро качество, лесно за употреба.", 
          en: "Good quality, easy to use."
        }, 
        date: { bg: "28 окт. 2024", en: "Oct 28, 2024" } 
      },
      { 
        name: { bg: "Анна Стойкова", en: "Anna Stoykova" }, 
        rating: 5, 
        comment: { 
          bg: "Използвам вече 3 месеца и разликата е невероятна! Косата расте по-бързо и е по-здрава.", 
          en: "I've been using it for 3 months now and the difference is incredible! My hair grows faster and is healthier."
        }, 
        date: { bg: "25 окт. 2024", en: "Oct 25, 2024" } 
      }
    ],
    2: [ // Newest by Mastelli Aesthetics - 35 total, 6 with text
      { 
        name: { bg: "Красимира Тодорова", en: "Krasimira Todorova" }, 
        rating: 5, 
        comment: { 
          bg: "Изключителни резултати! Кожата ми изглежда 10 години по-млада.", 
          en: "Exceptional results! My skin looks 10 years younger."
        }, 
        date: { bg: "20 ноем. 2024", en: "Nov 20, 2024" } 
      },
      { 
        name: { bg: "Иван Маринов", en: "Ivan Marinov" }, 
        rating: 5, 
        comment: { 
          bg: "Професионален продукт с видими резултати от първата процедура.", 
          en: "Professional product with visible results from the first procedure."
        }, 
        date: { bg: "14 ноем. 2024", en: "Nov 14, 2024" } 
      },
      { 
        name: { bg: "Десислава Христова", en: "Desislava Hristova" }, 
        rating: 4, 
        comment: { 
          bg: "Много съм доволна от ефекта. Кожата е по-стегната и сияйна.", 
          en: "I'm very satisfied with the effect. The skin is tighter and more radiant."
        }, 
        date: { bg: "10 ноем. 2024", en: "Nov 10, 2024" } 
      },
      { 
        name: { bg: "Галина Петкова", en: "Galina Petkova" }, 
        rating: 4, 
        comment: { 
          bg: "Отличен продукт за биоревитализация.", 
          en: "Excellent product for biorevitalization."
        }, 
        date: { bg: "5 ноем. 2024", en: "Nov 5, 2024" } 
      },
      { 
        name: { bg: "Николай Димитров", en: "Nikolay Dimitrov" }, 
        rating: 5, 
        comment: { 
          bg: "Препоръчвам на всички!", 
          en: "I recommend it to everyone!"
        }, 
        date: { bg: "30 окт. 2024", en: "Oct 30, 2024" } 
      },
      { 
        name: { bg: "Светлана Георгиева", en: "Svetlana Georgieva" }, 
        rating: 5, 
        comment: { 
          bg: "Най-добрата инвестиция в моята кожа. Ефектът е дълготраен и естествен.", 
          en: "The best investment in my skin. The effect is long-lasting and natural."
        }, 
        date: { bg: "26 окт. 2024", en: "Oct 26, 2024" } 
      }
    ],
    3: [ // P.O.M. 1 Trillion Exosomes - 42 total, 7 with text
      { 
        name: { bg: "Виолета Методиева", en: "Violeta Metodieva" }, 
        rating: 5, 
        comment: { 
          bg: "Най-авангардния продукт, който съм използвала! Невероятна регенерация на кожата.", 
          en: "The most avant-garde product I've ever used! Amazing skin regeneration."
        }, 
        date: { bg: "18 ноем. 2024", en: "Nov 18, 2024" } 
      },
      { 
        name: { bg: "Стефан Василев", en: "Stefan Vasilev" }, 
        rating: 5, 
        comment: { 
          bg: "Иновативна технология с изключителни резултати.", 
          en: "Innovative technology with exceptional results."
        }, 
        date: { bg: "12 ноем. 2024", en: "Nov 12, 2024" } 
      },
      { 
        name: { bg: "Румяна Георгиева", en: "Rumyana Georgieva" }, 
        rating: 4, 
        comment: { 
          bg: "Скъп, но си заслужава всяка стотинка.", 
          en: "Expensive, but worth every penny."
        }, 
        date: { bg: "7 ноем. 2024", en: "Nov 7, 2024" } 
      },
      { 
        name: { bg: "Мариана Стоянова", en: "Mariana Stoyanova" }, 
        rating: 5, 
        comment: { 
          bg: "Професионален продукт от най-високо качество.", 
          en: "Professional product of the highest quality."
        }, 
        date: { bg: "3 ноем. 2024", en: "Nov 3, 2024" } 
      },
      { 
        name: { bg: "Владислав Петров", en: "Vladislav Petrov" }, 
        rating: 5, 
        comment: { 
          bg: "Кожата ми никога не е изглеждала по-добре. Това е бъдещето на козметиката.", 
          en: "My skin has never looked better. This is the future of cosmetics."
        }, 
        date: { bg: "29 окт. 2024", en: "Oct 29, 2024" } 
      },
      { 
        name: { bg: "Теодора Илиева", en: "Teodora Ilieva" }, 
        rating: 4, 
        comment: { 
          bg: "Видими резултати още от първата седмица. Впечатляваща технология.", 
          en: "Visible results from the first week. Impressive technology."
        }, 
        date: { bg: "24 окт. 2024", en: "Oct 24, 2024" } 
      },
      { 
        name: { bg: "Борислав Тодоров", en: "Borislav Todorov" }, 
        rating: 5, 
        comment: { 
          bg: "Инвестицията си заслужава. Ефектът е дълготраен и естествен.", 
          en: "The investment is worth it. The effect is long-lasting and natural."
        }, 
        date: { bg: "20 окт. 2024", en: "Oct 20, 2024" } 
      }
    ],
    4: [ // P.O.M. 100 Billion Exosomes - 38 total, 6 with text
      { 
        name: { bg: "Цветелина Николова", en: "Tsvetelina Nikolova" }, 
        rating: 4, 
        comment: { 
          bg: "Много добър продукт за регенерация. Виждам подобрение след всяка процедура.", 
          en: "Very good product for regeneration. I see improvement after each procedure."
        }, 
        date: { bg: "16 ноем. 2024", en: "Nov 16, 2024" } 
      },
      { 
        name: { bg: "Георги Петров", en: "Georgi Petrov" }, 
        rating: 5, 
        comment: { 
          bg: "Отличен ефект върху кожата. Препоръчвам!", 
          en: "Excellent effect on the skin. I recommend it!"
        }, 
        date: { bg: "11 ноем. 2024", en: "Nov 11, 2024" } 
      },
      { 
        name: { bg: "Силвия Атанасова", en: "Silvia Atanasova" }, 
        rating: 4, 
        comment: { 
          bg: "Добро съотношение качество-цена.", 
          en: "Good value for money."
        }, 
        date: { bg: "6 ноем. 2024", en: "Nov 6, 2024" } 
      },
      { 
        name: { bg: "Веселина Димитрова", en: "Veselina Dimitrova" }, 
        rating: 4, 
        comment: { 
          bg: "Видими резултати след няколко процедури.", 
          en: "Visible results after several procedures."
        }, 
        date: { bg: "1 ноем. 2024", en: "Nov 1, 2024" } 
      },
      { 
        name: { bg: "Радослав Стефанов", en: "Radoslav Stefanov" }, 
        rating: 5, 
        comment: { 
          bg: "Много съм доволен от покупката.", 
          en: "I'm very pleased with the purchase."
        }, 
        date: { bg: "27 окт. 2024", en: "Oct 27, 2024" } 
      },
      { 
        name: { bg: "Мария Христова", en: "Maria Hristova" }, 
        rating: 5, 
        comment: { 
          bg: "Кожата ми стана по-еластична и сияйна. Препоръчвам топло!", 
          en: "My skin became more elastic and radiant. I highly recommend it!"
        }, 
        date: { bg: "22 окт. 2024", en: "Oct 22, 2024" } 
      }
    ],
    5: [ // P.O.M. PRP from Cord Blood Plasma - 29 total, 5 with text
      { 
        name: { bg: "Диана Благоева", en: "Diana Blagoeva" }, 
        rating: 5, 
        comment: { 
          bg: "PRP терапията с този продукт даде невероятни резултати! Кожата ми изглежда значително по-млада.", 
          en: "PRP therapy with this product gave amazing results! My skin looks significantly younger."
        }, 
        date: { bg: "19 ноем. 2024", en: "Nov 19, 2024" } 
      },
      { 
        name: { bg: "Христо Маринов", en: "Hristo Marinov" }, 
        rating: 4, 
        comment: { 
          bg: "Добър продукт за регенерация, макар и процедурата да е малко болезнена.", 
          en: "Good product for regeneration, although the procedure is a bit painful."
        }, 
        date: { bg: "13 ноем. 2024", en: "Nov 13, 2024" } 
      },
      { 
        name: { bg: "Златка Петрова", en: "Zlatka Petrova" }, 
        rating: 5, 
        comment: { 
          bg: "Отлични резултати за подмладяване.", 
          en: "Excellent results for rejuvenation."
        }, 
        date: { bg: "9 ноем. 2024", en: "Nov 9, 2024" } 
      },
      { 
        name: { bg: "Емилия Николова", en: "Emilia Nikolova" }, 
        rating: 5, 
        comment: { 
          bg: "Препоръчвам за всички, които търсят естествени методи за подмладяване.", 
          en: "I recommend it for everyone looking for natural rejuvenation methods."
        }, 
        date: { bg: "4 ноем. 2024", en: "Nov 4, 2024" } 
      },
      { 
        name: { bg: "Калина Стефанова", en: "Kalina Stefanova" }, 
        rating: 4, 
        comment: { 
          bg: "Естествен начин за подмладяване с доказани резултати.", 
          en: "Natural way for rejuvenation with proven results."
        }, 
        date: { bg: "31 окт. 2024", en: "Oct 31, 2024" } 
      }
    ],
    6: [ // Plinest Eye by Mastelli Aesthetics - 33 total, 6 with text
      { 
        name: { bg: "Росица Иванова", en: "Rositsa Ivanova" }, 
        rating: 5, 
        comment: { 
          bg: "Изключителен продукт за зоната около очите! Бръчките са значително намалени.", 
          en: "Exceptional product for the eye area! Wrinkles are significantly reduced."
        }, 
        date: { bg: "17 ноем. 2024", en: "Nov 17, 2024" } 
      },
      { 
        name: { bg: "Тодор Стойков", en: "Todor Stoykov" }, 
        rating: 4, 
        comment: { 
          bg: "Добър ефект, но трябва търпение за видими резултати.", 
          en: "Good effect, but patience is needed for visible results."
        }, 
        date: { bg: "12 ноем. 2024", en: "Nov 12, 2024" } 
      },
      { 
        name: { bg: "Камелия Тодорова", en: "Kamelia Todorova" }, 
        rating: 5, 
        comment: { 
          bg: "Най-добрият продукт за очи, който съм използвала!", 
          en: "The best eye product I've ever used!"
        }, 
        date: { bg: "8 ноем. 2024", en: "Nov 8, 2024" } 
      },
      { 
        name: { bg: "Милена Петкова", en: "Milena Petkova" }, 
        rating: 4, 
        comment: { 
          bg: "Деликатен и ефективен продукт.", 
          en: "Delicate and effective product."
        }, 
        date: { bg: "3 ноем. 2024", en: "Nov 3, 2024" } 
      },
      { 
        name: { bg: "Пламен Николов", en: "Plamen Nikolov" }, 
        rating: 5, 
        comment: { 
          bg: "Отличен за тъмните кръгове под очите.", 
          en: "Excellent for dark circles under the eyes."
        }, 
        date: { bg: "29 окт. 2024", en: "Oct 29, 2024" } 
      },
      { 
        name: { bg: "Десислава Маринова", en: "Desislava Marinova" }, 
        rating: 5, 
        comment: { 
          bg: "Очите ми изглеждат по-млади и свежи. Много съм доволна!", 
          en: "My eyes look younger and fresher. I'm very satisfied!"
        }, 
        date: { bg: "25 окт. 2024", en: "Oct 25, 2024" } 
      }
    ],
    7: [ // Plinest One by Mastelli Aesthetics - 47 total, 8 with text
      { 
        name: { bg: "Стела Георгиева", en: "Stela Georgieva" }, 
        rating: 5, 
        comment: { 
          bg: "Универсален продукт с невероятни резултати! Използвам го за лице и тяло.", 
          en: "Universal product with amazing results! I use it for face and body."
        }, 
        date: { bg: "21 ноем. 2024", en: "Nov 21, 2024" } 
      },
      { 
        name: { bg: "Владимир Атанасов", en: "Vladimir Atanasov" }, 
        rating: 4, 
        comment: { 
          bg: "Много добър продукт за цялостно подмладяване.", 
          en: "Very good product for comprehensive rejuvenation."
        }, 
        date: { bg: "15 ноем. 2024", en: "Nov 15, 2024" } 
      },
      { 
        name: { bg: "Йорданка Стефанова", en: "Yordanka Stefanova" }, 
        rating: 5, 
        comment: { 
          bg: "Препоръчвам на всички! Кожата стана по-еластична и сияйна.", 
          en: "I recommend it to everyone! The skin became more elastic and radiant."
        }, 
        date: { bg: "11 ноем. 2024", en: "Nov 11, 2024" } 
      },
      { 
        name: { bg: "Венелина Петрова", en: "Venelina Petrova" }, 
        rating: 4, 
        comment: { 
          bg: "Отличен за стрии и белези.", 
          en: "Excellent for stretch marks and scars."
        }, 
        date: { bg: "6 ноем. 2024", en: "Nov 6, 2024" } 
      },
      { 
        name: { bg: "Кирил Иванов", en: "Kiril Ivanov" }, 
        rating: 5, 
        comment: { 
          bg: "Професионален продукт с доказана ефективност.", 
          en: "Professional product with proven effectiveness."
        }, 
        date: { bg: "2 ноем. 2024", en: "Nov 2, 2024" } 
      },
      { 
        name: { bg: "Теодора Николова", en: "Teodora Nikolova" }, 
        rating: 5, 
        comment: { 
          bg: "Най-добрата инвестиция в красотата ми!", 
          en: "The best investment in my beauty!"
        }, 
        date: { bg: "28 окт. 2024", en: "Oct 28, 2024" } 
      },
      { 
        name: { bg: "Антон Димитров", en: "Anton Dimitrov" }, 
        rating: 4, 
        comment: { 
          bg: "Виждам подобрение в тона и текстурата на кожата.", 
          en: "I see improvement in the tone and texture of the skin."
        }, 
        date: { bg: "24 окт. 2024", en: "Oct 24, 2024" } 
      },
      { 
        name: { bg: "Ивана Петкова", en: "Ivana Petkova" }, 
        rating: 5, 
        comment: { 
          bg: "Многофункционален продукт с отлични резултати за цялото тяло.", 
          en: "Multifunctional product with excellent results for the whole body."
        }, 
        date: { bg: "21 окт. 2024", en: "Oct 21, 2024" } 
      }
    ]
  };
  
  const totalReviews = {
    1: 25,
    2: 35,
    3: 42,
    4: 38,
    5: 29,
    6: 33,
    7: 47
  };
  
  return {
    textReviews: reviewsData[productId] || [],
    totalCount: totalReviews[productId] || 0
  };
};

const StarRating = ({ rating, size = "small" }) => {
  const starSize = size === "large" ? "star-large" : "";
  return (
    <div className={`star-rating ${starSize}`}>
      {[1, 2, 3, 4, 5].map(star => (
        <span key={star} className={star <= rating ? 'star filled' : 'star'}>★</span>
      ))}
    </div>
  );
};

const ProductDetail = ({ product, onBack, language = 'bg' }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const navigate = useNavigate();
  const { textReviews, totalCount } = generateReviews(product.id);
  const averageRating = totalCount > 0 ? 
    (textReviews.reduce((sum, review) => sum + review.rating, 0) / textReviews.length).toFixed(1) : 0;

  useEffect(() => {
    const timer = setTimeout(() => setImageLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const handleImageClick = () => {
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
  };

  const handleInquire = () => {
    // Navigate to contact page
    navigate('/contact');
  };

  const getShortDescription = (id) => {
    const shortDescriptions = {
      1: {
        bg: "Иновативен продукт за растеж на коса, съдържащ Fullerene C60 - мощен антиоксидант с доказани регенеративни свойства.",
        en: "Innovative hair growth product containing Fullerene C60 - a powerful antioxidant with proven regenerative properties."
      },
      2: {
        bg: "Професионален биорепарант с хиалуронова киселина и полинуклеотид за интензивна регенерация на кожата.",
        en: "Professional bio-reparant with hyaluronic acid and polynucleotide for intensive skin regeneration."
      },
      3: {
        bg: "Най-концентрираният екзозомен продукт на пазара, съдържащ 1 трилион екзозоми за максимална регенерация.",
        en: "The most concentrated exosome product on the market, containing 1 trillion exosomes for maximum regeneration."
      },
      4: {
        bg: "Висококачествен екзозомен продукт с 100 милиарда екзозоми за естествена регенерация на кожата.",
        en: "High-quality exosome product with 100 billion exosomes for natural skin regeneration."
      },
      5: {
        bg: "PRP терапия с кордова плазма, богата на растежни фактори за естествено подмладяване.",
        en: "PRP therapy with cord plasma, rich in growth factors for natural rejuvenation."
      },
      6: {
        bg: "Специализиран продукт за зоната около очите, съдържащ PDRN в концентрация 7.5 mg/ml.",
        en: "Specialized product for the eye area, containing PDRN at a concentration of 7.5 mg/ml."
      },
      7: {
        bg: "Универсален биорепарант с PDRN за цялостно подмладяване на лице и тяло.",
        en: "Universal bio-reparant with PDRN for comprehensive rejuvenation of face and body."
      }
    };
    return shortDescriptions[id]?.[language] || shortDescriptions[id]?.bg || "";
  };

  const getFullDescription = (id) => {
    return product.fullDescription[language] || product.fullDescription.bg || "";
  };

  const getDetailedInfo = (id) => {
    return product.detailedInfo[language] || product.detailedInfo.bg || "";
  };

  return (
    <div className="product-detail">
      <div className="product-detail-container">
        <button className="back-btn" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M19 12H5m7-7l-7 7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {t('Назад към продуктите', language)}
        </button>
        
        <div className="product-layout">
          {/* Left Column - Image */}
          <div className="product-left-column">
            <div className={`product-detail-image-wrap ${imageLoaded ? 'loaded' : ''}`} onClick={handleImageClick}>
              <img 
                src={product.image} 
                alt={product.name} 
                className="product-detail-image"
                onLoad={() => setImageLoaded(true)}
              />
            </div>
            
            {/* Sticky Buy Button */}
            <div className="sticky-buy-button">
              <button className="inquire-btn" onClick={handleInquire}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M3 8l7.89 7.89a2 2 0 002.82 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {t('Направи запитване', language)}
              </button>
            </div>
          </div>

          {/* Right Column - Content */}
          <div className="product-right-column">
            <div className="product-header-section">
              <div className="product-category-pill">{t(product.category, language)}</div>
              <h1 className="product-detail-title">{t(product.name, language)}</h1>
              <div className="product-rating-summary">
                <StarRating rating={Math.round(averageRating)} size="large" />
                <span className="rating-text">({averageRating}) • {totalCount} {t('отзива', language)}</span>
              </div>
            </div>

            <div className="product-content-sections">
              <div className="product-section short-desc-section">
                <h2>{t('Кратко описание', language)}</h2>
                <p className="short-description mobile-visible">{getShortDescription(product.id)}</p>
              </div>

              <div className="product-section detailed-desc-section">
                <h2>{t('Подробно описание', language)}</h2>
                <div className="description-content mobile-visible">
                  <p>{getFullDescription(product.id)}</p>
                </div>
              </div>

              <div className="product-section reviews-section">
                <h2>{t('Отзиви', language)} ({totalCount})</h2>
                <div className="reviews-masonry">
                  {textReviews.map((review, index) => (
                    <div key={index} className="review-card">
                      <div className="review-header">
                        <div className="reviewer-info">
                          <span className="reviewer-name">{review.name[language] || review.name.bg}</span>
                          <StarRating rating={review.rating} />
                        </div>
                        <span className="review-date">{review.date[language] || review.date.bg}</span>
                      </div>
                      <p className="review-comment">{review.comment[language] || review.comment.bg}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {showImageModal && (
          <div className="image-modal" onClick={closeImageModal}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={closeImageModal}>×</button>
              <img src={product.image} alt={product.name} className="modal-image" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetail; 